export const RANKS = [
  { name: "Rookie", threshold: 0 },
  { name: "Bronze", threshold: 500 },
  { name: "Silber", threshold: 1500 },
  { name: "Gold", threshold: 3000 },
  { name: "Diamond", threshold: 6000 },
  { name: "Elite", threshold: 10000 },
];

export function nextRankInfo(total: number) {
  let current = "Rookie";
  for (const r of RANKS) if (total >= r.threshold) current = r.name;
  const idx = RANKS.findIndex((r) => r.name === current);
  if (idx < 0 || idx === RANKS.length - 1) return { current, next: null, needed: null, nextThreshold: null };
  const next = RANKS[idx + 1];
  return { current, next: next.name, needed: next.threshold - total, nextThreshold: next.threshold };
}
